import { routes } from '../routes/constants';

const getDisplayNameByPath = (pathname: string) => {
  const routeName = routes[pathname];
  return routeName?.displayName;
};

export default getDisplayNameByPath;
